import { fakeLogin } from '../../Start/services/fakeApi.js';
import { storageService } from './storageService.js';

/**
 * authService.js
 *
 * Core-level authentication logic. It knows how to log in and how to
 * persist/retrieve a session. It does NOT know what "doctor" or "shop"
 * mean — it just passes whatever `system` object the backend returned
 * further up the chain, untouched.
 */

export const authService = {
  async login(email, password) {
    const response = await fakeLogin(email, password);
    storageService.saveSession(response);
    return response;
  },

  logout() {
    storageService.clearSession();
  },

  getSession() {
    return storageService.loadSession();
  },

  isAuthenticated() {
    return Boolean(storageService.loadSession());
  },
};
